import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useState, useEffect } from 'react';
import { CircularProgress, Divider } from '@mui/material';
import FormCategories from './FormCategories';
import axios from './../../axios/api';
import './styles.css'; // Import the CSS file

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    border: '0.2px solid #eee',
    borderRadius: 5,
    boxShadow: 24,
    p: 4,
    overflowY: 'auto', // Enable vertical scrolling for the content
    maxHeight: '85vh', // Set max height for modal content

};

const EditCategories = ({ open, handleCloseModal, id, refreshData }) => {
    console.log("open Status" + open);
    const [openModal, setOpenModal] = useState(open);
    const [isLoading, setIsLoading] = useState(false);
    const [Data, setData] = useState([]);

    const handleClose = () => {
        setOpenModal(false);
        handleCloseModal();

    };
    useEffect(() => {
        setData([]);
        getDataSelected();
    }, [id])

    const getDataSelected = async () => {
        try {
            setIsLoading(true);
            let url = `/admin/category/show/${id}`;
            const res = await axios.get(url);
            setData(res.data?.data);
        } catch (e) {
            console.log(e.response, "eeeeeeeee");
        } finally {
            setIsLoading(false);
        }
    };



    return (
        <Modal
            open={openModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style} className="hide-scrollbar">
                {isLoading ?
                    <Box mt={2} display="flex" flexDirection="row" alignItems="center" justifyContent="center" >
                        <CircularProgress size={24} color="inherit" />
                    </Box>
                    :
                    <>
                        <Typography variant='h4' textAlign="center">ویرایش اطلاعات دسته بندی</Typography>
                        <Divider sx={{ my: 2 }} />
                        <FormCategories
                            IdEdit={id}
                            isEdit
                            DataEdit={Data}
                            refreshData={refreshData}
                            handleCloseModal={handleCloseModal}
                        />
                    </>
                }
            </Box>
        </Modal>
    );
}
export default EditCategories;